import { render, staticRenderFns } from "./RegisterQuestion.vue?vue&type=template&id=c11bd8aa"
import script from "./RegisterQuestion.vue?vue&type=script&lang=js"
export * from "./RegisterQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports